export default __webpack_public_path__ + "static/4-societal-collapse-e5883d6f584eadff1e4e09b88868b11e.png";